module.exports = __webpack_public_path__ + "static/media/awesome.85528998.gif";